import { render, staticRenderFns } from "./OverseaActiveReportPage.vue?vue&type=template&id=9b7fe81a&scoped=true"
import script from "./OverseaActiveReportPage.vue?vue&type=script&lang=js"
export * from "./OverseaActiveReportPage.vue?vue&type=script&lang=js"
import style0 from "./OverseaActiveReportPage.vue?vue&type=style&index=0&id=9b7fe81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7fe81a",
  null
  
)

export default component.exports